import { UseFormRegister } from "react-hook-form";
import { useIntl } from "react-intl";
import { styled } from "stitches.config";
import { Input } from "../form";
import { CompoundInterestsFormValues } from "@/hooks/simulators/useCompoundInterestsSimulatorForm";

export type CompoundInterestsFormProps = {
    register: UseFormRegister<CompoundInterestsFormValues>;
}

export const CompoundInterestsForm = ({register}: CompoundInterestsFormProps) => {
    const { formatMessage } = useIntl();

    return (
      <FormContainer>
        <Input
          autoFocus
          min={0}
          type="number"
          suffix={formatMessage({ id: 'compound_interests_simulator.form.initial_capital.suffix' })}
          label={formatMessage({ id: 'compound_interests_simulator.form.initial_capital.label' })}
          tooltipInfos={formatMessage({ id: 'compound_interests_simulator.form.initial_capital.tooltip' })}
          placeholder={formatMessage({ id: 'compound_interests_simulator.form.initial_capital.placeholer' })}
          {...register('initial_capital', {
            valueAsNumber: true,
          })}
         />
        <Input
          min={0}
          type="number"
          suffix={formatMessage({ id: 'compound_interests_simulator.form.monthly_savings.suffix' })}
          label={formatMessage({ id: 'compound_interests_simulator.form.monthly_savings.label' })}
          tooltipInfos={formatMessage({ id: 'compound_interests_simulator.form.monthly_savings.tooltip' })}
          placeholder={formatMessage({ id: 'compound_interests_simulator.form.monthly_savings.placeholer' })}
          {...register('monthly_savings', {
            valueAsNumber: true,
          })}
         />
        <Input
          min={0}
          type="number"
          suffix={formatMessage({ id: 'compound_interests_simulator.form.investment_horizon.suffix' })}
          label={formatMessage({ id: 'compound_interests_simulator.form.investment_horizon.label' })}
          placeholder={formatMessage({ id: 'compound_interests_simulator.form.investment_horizon.placeholer' })}
          {...register('investment_horizon', {
            valueAsNumber: true,
          })}
         />
        <Input
          min={0}
          type="number"
          suffix={formatMessage({ id: 'compound_interests_simulator.form.interest_rate.suffix' })}
          label={formatMessage({ id: 'compound_interests_simulator.form.interest_rate.label' })}
          tooltipInfos={formatMessage({ id: 'compound_interests_simulator.form.interest_rate.tooltip' })}
          placeholder={formatMessage({ id: 'compound_interests_simulator.form.interest_rate.placeholer' })}
          {...register('interest_rate', {
            valueAsNumber: true,
          })}
         />
        <Input
          min={0}
          type="number"
          suffix={formatMessage({ id: 'compound_interests_simulator.form.interest_rate_every_x_months.suffix' })}
          label={formatMessage({ id: 'compound_interests_simulator.form.interest_rate_every_x_months.label' })}
          tooltipInfos={formatMessage({ id: 'compound_interests_simulator.form.interest_rate_every_x_months.tooltip' })}
          placeholder={formatMessage({ id: 'compound_interests_simulator.form.interest_rate_every_x_months.placeholer' })}
          {...register('interest_rate_every_x_months', {
            valueAsNumber: true,
          })}
         />
      </FormContainer>
    )
}

const FormContainer = styled('section', {
    gap: '$8',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid $borderSecondary',
    padding: '$10',
    '@sm': {
      border: 'none',
      padding: '$8',
    },
});